import { useState } from "react";

export function useCooldown(delay = 500) {
    const [cooldownTime, setCooldownTime] = useState<number>(0);

    const trigger = () => {
        const now = Date.now();
        if (now - cooldownTime < delay) {
            return false; // Still in cooldown
        }
        setCooldownTime(now);
        return true; // Cooldown expired, proceed
    }

    const reset = () => {
        setCooldownTime(0); // Reset cooldown
    };

    return [trigger, reset] as const;
}